import DatePicker from "components/app/function/DatePicker";
import NumberInput from "components/app/function/NumberInput";
import SelectOption from "components/app/function/SelectOption";
import TextInput from "components/app/function/TextInput";
import { Button } from "components/ui/button";
import { Label } from "components/ui/label";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

import { LoaderCircle, UserRoundPen, X } from "lucide-react";
import { useEffect, useState } from "react";
import { flagCambodia } from "assets";
import { Textarea } from "components/ui/textarea";
import DialogOTP from "components/app/dialog/DialogOTP";
import { Service } from "utils/services";
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from "components/app/sheet/sheet";

interface DialogProps {
  userProfileDetail: any;
  onValueChange: (value: any) => void;
}

export default function DailogEditUserProfile({ userProfileDetail, onValueChange }: DialogProps) {
  const [countryCode, setCountryCode] = useState<number | string>();
  const [phoneNumber, setPhoneNumber] = useState<number | string>();
  const [nameInput, setNameInput] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [emailInput, setEmailInput] = useState<string>("");
  const [genderInput, setGenderInput] = useState<string>("");
  const [dateOfBirth, setDateOfBirth] = useState<string>("");
  const [bioInput, setBioInput] = useState<string>("");
  const [descriptionInput, setDescriptionInput] = useState<string>("");
  const [facebookInput, setFacebookInput] = useState<string>("");
  const [telegramInput, setTelegramInput] = useState<string>("");
  const [tikTokInput, setTikTokInput] = useState<string>("");
  const [youTubeInput, setYouTubeInput] = useState<string>("");
  const [googelInput, setGoogelInput] = useState<string>("");
  const { token } = useAppSelector((state) => state.auth);

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [isDialogOTPOpen, setIsDialogOTPOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingProfileEdit, setisLoadingProfile] = useState<boolean>(false);
  const [tokenVerification, setTokenVerification] = useState<string>("");

  const submitProfileApi = async () => {
    try {
      const url = `${RouteApi.submitUpdateProfileInformation}token=${token}`;
      const data = {
        phone_no: phoneNumber,
        name: nameInput,
        username: userName,
        user_email: emailInput,
        gender: genderInput,
        date_of_birth: dateOfBirth,
        bio: bioInput,
        description: descriptionInput,
        country_code: countryCode,
        facebook_link: facebookInput,
        telegram_link: telegramInput,
        tiktok_link: tikTokInput,
        youtube_link: youTubeInput,
        google_map_link: googelInput,
      };
      setisLoadingProfile(true);
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setisLoadingProfile(false);
        onValueChange(response.user);
        localStorage.setItem("user", JSON.stringify(response.user));
        setIsDialogOpen(false);
      } else {
        setisLoadingProfile(false);
      }
    } catch (error) {
      AppLog.show({
        message: `[submitProfileApi]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onClickedVerificationEmail = async () => {
    try {
      if (!emailInput) {
        return;
      }
      const url = `${RouteApi.postUserIdentityVerification}token=${token}`;
      const data = {
        verify_type: "email_address",
        verify_value: emailInput,
        country_code: Service?.userAuth.country_code,
      };
      setIsLoading(true);
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setTokenVerification(response.user_identify_verification.token);
        setIsDialogOTPOpen(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
      console.log("response : ", response);
    } catch (error) {
      AppLog.show({
        message: `[onClickedVerificationEmail]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onClickedVerificationPhone = async () => {
    try {
      if (!emailInput) {
        return;
      }
      const url = `${RouteApi.postUserIdentityVerification}token=${token}`;
      const data = {
        verify_type: "phone_number",
        verify_value: phoneNumber,
        country_code: Service?.userAuth.country_code,
      };
      setIsLoading(true);
      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        setTokenVerification(response.user_identify_verification.token);
        setIsDialogOTPOpen(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
      console.log("response : ", response);
    } catch (error) {
      AppLog.show({
        message: `[onClickedVerificationPhone]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    const { phone_no, bio, country_code, name, username, user_email, gender, date_of_birth, facebook_link, telegram_link, tiktok_link, youtube_link, google_map_link } =
      userProfileDetail;
    setPhoneNumber(phone_no);
    setNameInput(name);
    setUserName(username);
    setEmailInput(user_email);
    setGenderInput(gender);
    setDateOfBirth(date_of_birth);
    setBioInput(bio);
    setFacebookInput(facebook_link);
    setTelegramInput(telegram_link);
    setYouTubeInput(youtube_link);
    setTikTokInput(tiktok_link);
    setGoogelInput(google_map_link);
    setCountryCode(country_code);
  }, [userProfileDetail]);

  // const handleSave = () => {
  //   const {
  //     phone_no,
  //     bio,
  //     name,
  //     username,
  //     user_email,
  //     gender,
  //     date_of_birth,
  //     facebook_link,
  //     telegram_link,
  //     youtube_link,
  //     tiktok_link,
  //     google_map_link,
  //   } = userProfileDetail;
  //   if (
  //     phoneNumber !== phone_no ||
  //     nameInput !== name ||
  //     userName !== username ||
  //     emailInput !== user_email ||
  //     genderInput !== gender ||
  //     dateOfBirth !== date_of_birth ||
  //     bioInput !== bio ||
  //     facebookInput !== facebook_link ||
  //     telegramInput !== telegram_link ||
  //     youTubeInput !== youtube_link ||
  //     tikTokInput !== tiktok_link ||
  //     googelInput !== google_map_link
  //   ) {
  //     submitProfileApi();
  //   }
  // };
  return (
    <>
      <Sheet open={isDialogOpen}>
        <SheetTrigger
          onClick={() => {
            setIsDialogOpen(true);
          }}
          asChild
        >
          <UserRoundPen className="p-1 bg-gray-50 dark:bg-accent dark:hover:bg-slate-900 hover:bg-accent hover:text-accent-foreground w-9 h-9 rounded-full border cursor-pointer" />
        </SheetTrigger>
        <SheetContent isShowBtnXClose={false} className="p-0 pb-2">
          <div
            className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
            onClick={() => {
              setIsDialogOpen(false);
            }}
          >
            <X />
          </div>
          <div className="flex flex-col items-center justify-between h-full">
            <SheetTitle className="text-start w-full px-3 ">Edit Profile Detail</SheetTitle>
            <SheetHeader className="mx-4 mt-2">
              <SheetDescription>Modify your profile here, then click "Save" when you’re finished</SheetDescription>
            </SheetHeader>
            <ScrollArea className="mt-2 w-full h-full">
              <div className="space-y-2 mx-4 pb-6">
                <div className="space-y-1">
                  <Label htmlFor="country" className="">
                    Country Code
                  </Label>
                  <div className="relative">
                    <img src={flagCambodia} alt="Cambodia Flag" className="absolute left-2 top-1/2 transform -translate-y-1/2 w-10 h-6 object-cover" />
                    <TextInput disabled id="country" defaultValue={userProfileDetail?.country_code} className="text-[14px] pl-14" />
                  </div>
                </div>

                <div className="space-y-1">
                  <Label htmlFor="phone_number">Phone Number</Label>
                  <div className="relative">
                    <NumberInput
                      onChange={(event) => setPhoneNumber(event.target.value)}
                      id="phone_number"
                      defaultValue={userProfileDetail?.phone_no}
                      className="text-[14px] w-full rounded-md px-3 py-2 pr-16"
                    />
                    {userProfileDetail?.phone_no_verified === "Yes"
                      ? phoneNumber === userProfileDetail?.phone_no && (
                          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-green-600 font-medium">Verified</span>
                        )
                      : phoneNumber === userProfileDetail?.phone_no && (
                          <span
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-yellow-500 font-medium cursor-pointer"
                            onClick={onClickedVerificationPhone}
                          >
                            Send Verify
                          </span>
                        )}
                  </div>
                </div>

                <div className="space-y-1">
                  <Label htmlFor="name" className="">
                    Name
                  </Label>
                  <TextInput onChange={(event) => setNameInput(event.target.value)} id="name" defaultValue={userProfileDetail?.name} className="text-[14px]" />
                </div>

                <div className="space-y-1">
                  <Label htmlFor="username" className="">
                    Username
                  </Label>
                  <TextInput onChange={(event) => setUserName(event.target.value)} id="username" defaultValue={userProfileDetail?.username} className="text-[14px]" />
                </div>
                <div className="space-y-1">
                  <Label htmlFor="email" className="">
                    Email
                  </Label>
                  <div className="relative">
                    <TextInput
                      onChange={(event) => setEmailInput(event.target.value)}
                      id="email"
                      defaultValue={userProfileDetail?.user_email}
                      className="text-[14px] w-full border border-gray-300 rounded-md px-3 py-2 pr-16 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {userProfileDetail?.user_email_verified === "Yes"
                      ? emailInput === userProfileDetail?.user_email && (
                          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-green-600 font-medium">Verified</span>
                        )
                      : emailInput === userProfileDetail?.user_email && (
                          <span
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-yellow-500 font-medium cursor-pointer"
                            onClick={onClickedVerificationEmail}
                          >
                            Send Verify
                          </span>
                        )}
                  </div>
                </div>

                <div className="space-y-1">
                  <Label htmlFor="gender" className="">
                    Gender
                  </Label>
                  <SelectOption
                    value={userProfileDetail?.gender}
                    item={[
                      { value: "Male", label: "Male" },
                      { value: "Female", label: "Female" },
                      { value: " ", label: " " },
                    ]}
                    onValueChange={(value) => setGenderInput(value)}
                  />
                </div>

                <div className="space-y-1">
                  <Label htmlFor="Date of Birth" className="">
                    Date of Birth
                  </Label>
                  <DatePicker value={userProfileDetail?.date_of_birth} className="mt-1" onChange={(value) => setDateOfBirth(value)} />
                </div>

                <div className="space-y-1">
                  <Label htmlFor="bio" className="">
                    Bio
                  </Label>
                  <Textarea onChange={(event) => setBioInput(event.target.value)} id="bio" defaultValue={userProfileDetail?.bio} className="text-[14px]" maxLength={255} />
                  <div className="text-right text-xs font-semibold">{bioInput?.length}/255</div>
                </div>

                <div className="space-y-1">
                  <Label htmlFor="description" className="">
                    Description
                  </Label>
                  <Textarea onChange={(event) => setDescriptionInput(event.target.value)} id="description" defaultValue={userProfileDetail?.description} className="text-[14px]" />
                </div>

                <div className="space-y-1">
                  <Label htmlFor="facebook_link" className="">
                    Facebook Link
                  </Label>
                  <TextInput
                    onChange={(event) => setFacebookInput(event.target.value)}
                    id="facebook_link"
                    defaultValue={userProfileDetail?.facebook_link}
                    className="text-[14px]"
                  />
                </div>

                <div className="space-y-1">
                  <Label htmlFor="telegram_link" className="">
                    Telegram Link
                  </Label>
                  <TextInput
                    onChange={(event) => setTelegramInput(event.target.value)}
                    id="telegram_link"
                    defaultValue={userProfileDetail?.telegram_link}
                    className="text-[14px]"
                  />
                </div>
                <div className="space-y-1">
                  <Label htmlFor="username" className="">
                    Tiktok Link
                  </Label>
                  <TextInput onChange={(event) => setTikTokInput(event.target.value)} id="tiktok_link" defaultValue={userProfileDetail?.tiktok_link} className="text-[14px]" />
                </div>

                <div className="space-y-1">
                  <Label htmlFor="youtube_link" className="">
                    Youtube Link
                  </Label>
                  <TextInput onChange={(event) => setYouTubeInput(event.target.value)} id="youtube_link" defaultValue={userProfileDetail?.youtube_link} className="text-[14px]" />
                </div>

                <div className="space-y-1">
                  <Label htmlFor="google_map_link" className="">
                    Google Map Link
                  </Label>
                  <TextInput
                    onChange={(event) => setGoogelInput(event.target.value)}
                    id="google_map_link"
                    defaultValue={userProfileDetail?.google_map_link}
                    className="text-[14px]"
                  />
                </div>
              </div>
              <ScrollBar orientation="vertical" />
            </ScrollArea>
            <SheetFooter className="w-full px-4 mt-2">
              <SheetClose onClick={() => submitProfileApi()} className="w-full" asChild>
                <Button className="w-full bg-destructive text-white bg-blue-600 hover:bg-blue-500">Save</Button>
              </SheetClose>
            </SheetFooter>
            {isLoading && (
              <div className="w-full h-full bg-black bg-opacity-70 flex justify-center absolute items-center ">
                <LoaderCircle size={30} className="animate-spin text-yellow-400" />
              </div>
            )}
            {isLoadingProfileEdit && (
              <div className="w-full h-full bg-black bg-opacity-70 flex justify-center absolute items-center z-100 ">
                <LoaderCircle size={30} className="animate-spin text-yellow-400" />
              </div>
            )}
          </div>
        </SheetContent>
      </Sheet>
      <DialogOTP isDialogOpen={isDialogOTPOpen} setIsDialogOpen={setIsDialogOTPOpen} email={emailInput} token={tokenVerification} />
    </>
  );
}
